import styled from 'styled-components';
import { CardBase } from '../../../components/Card/styles';

export const Box = styled(CardBase)``;
